import React from 'react';
import { CSSObject, forBrands, Theme } from '@core-ui/react-stitch';
import FacetItem from '../FacetItem/FacetItem';
import isOptionApplied from './collaborators/is-option-applied';
import { SimpleFacetProps } from './types';
import { Option } from '../../../types';

const getLayoutStyles = (facetLayout: string): CSSObject => {
  switch (facetLayout) {
    case 'list':
      return {
        label: {
          span: {
            width: '100%',
          },
        },
      };
    case 'grid':
      return {
        display: 'flex',
        flexWrap: 'wrap',
      };
    default:
      return {};
  }
};

const SimpleFacet = (props: SimpleFacetProps) => {
  const {
    appliedFacets,
    facetDisplay,
    facetLayout,
    facetName,
    options,
    isMobile,
    isSwitchContractEnabled,
  } = props;

  const setFacetOptionsStylesForBananaRepublic = (): CSSObject => ({
    'div:last-of-type label': {
      marginBottom: '0',
    },
  });

  const facetOptionsStyle = (theme: Theme): CSSObject => ({
    listStyleType: 'none',
    padding: '0',
    label: {
      position: 'relative',
    },
    span: {
      display: 'block',
      boxSizing: 'border-box',
    },
    'input[type="checkbox"], input[type="radio"]': {
      boxSizing: 'border-box',
      opacity: '0',
      position: 'absolute',
      padding: '0',
    },
    ...getLayoutStyles(facetLayout),
    ...(forBrands(theme, {
      br: setFacetOptionsStylesForBananaRepublic,
      brfs: setFacetOptionsStylesForBananaRepublic,
    }) as CSSObject),
  });

  const brSimpleFacetStyle = (): CSSObject => ({
    padding: '0',
  });

  const getDefaultStyle = (): CSSObject => ({
    padding: '0.5rem 0',
  });

  const simpleFacetStyle = (theme: Theme): CSSObject => ({
    ...(forBrands(theme, {
      br: brSimpleFacetStyle,
      brfs: brSimpleFacetStyle,
      default: getDefaultStyle,
    }) as CSSObject),
  });

  const mobileSimpleFacetStyle = (): CSSObject => ({
    padding: '0.5rem 1rem',
  });

  const fluidSimpleFacetStyle = (theme: Theme) => {
    if (isMobile) return mobileSimpleFacetStyle();
    return simpleFacetStyle(theme);
  };

  const getAppliedValue = (option: Option) =>
    isOptionApplied(option, appliedFacets, facetName);

  return (
    <div css={fluidSimpleFacetStyle}>
      <div css={facetOptionsStyle}>
        {options
          .filter((option) => option.isActive === 'true')
          .map((option) => (
            <FacetItem
              key={option.id}
              applied={getAppliedValue(option)}
              facetDisplay={facetDisplay}
              facetName={facetName}
              isSwitchContractEnabled={isSwitchContractEnabled}
              option={option}
            />
          ))}
      </div>
    </div>
  );
};

export default SimpleFacet;
